"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyModalConnected = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const locale_1 = require("./locale");
const PrivacyModal_1 = __importDefault(require("./PrivacyModal/PrivacyModal"));
const usePrivacyText_1 = require("./PrivacyModal/usePrivacyText");
const storage_1 = __importDefault(require("./storage"));
const tracking_1 = require("./tracking");
const usePrivacyModalState_1 = require("./usePrivacyModalState");
const PrivacyModalConnected = ({ anonymize }) => {
    const { optIn } = (0, tracking_1.useTracking)();
    const privacyModalState = (0, usePrivacyModalState_1.usePrivacyModalState)(anonymize);
    const categories = react_1.default.useMemo(() => {
        return ['necessary', 'performance'];
    }, []);
    const handleOnOptInChange = react_1.default.useCallback((category, optedIn) => {
        if (category === 'performance') {
            optIn(optedIn);
        }
    }, [optIn]);
    if (privacyModalState === 'show') {
        return react_1.default.createElement(PrivacyModal_1.default, { onOptInChange: handleOnOptInChange, categories: categories });
    }
    return null;
};
exports.PrivacyModalConnected = PrivacyModalConnected;
const getLocale = (locale) => {
    if (locale === undefined) {
        return undefined;
    }
    else {
        return locale_1.locales.includes(locale) ? locale : 'en-US';
    }
};
const renderPrivacyModal = (amplitudeApiKey, localeInitial, anonymize) => {
    const element = document.createElement('div');
    document.body.appendChild(element);
    const renderToDom = (locale) => {
        react_dom_1.default.render(react_1.default.createElement(tracking_1.TrackingProvider, { amplitudeApiKey: amplitudeApiKey, customEventPrefix: "", defaultClickTracking: true, locale: locale, anonymize: anonymize },
            react_1.default.createElement(usePrivacyText_1.PrivacyTextProvider, { locale: locale },
                react_1.default.createElement(exports.PrivacyModalConnected, { anonymize: anonymize }))), element);
    };
    watchForLocaleChange((localeNext) => {
        const localeNextMapped = getLocale(localeNext);
        if (localeNextMapped) {
            renderToDom(localeNextMapped);
        }
    });
    renderToDom(localeInitial);
};
const replaceDeprecatedStorage = () => {
    const storageConsent = localStorage.getItem('MDRNA_CONSENT');
    const storageAmplitude = localStorage.getItem('MDRNA_AMPLITUDE');
    if (storageConsent !== null) {
        if (storage_1.default.getItem('MDRNA_CONSENT') === null) {
            storage_1.default.setItem('MDRNA_CONSENT', storageConsent);
        }
        localStorage.removeItem('MDRNA_CONSENT');
    }
    if (storageAmplitude !== null) {
        if (storage_1.default.getItem('MDRNA_AMPLITUDE') === null) {
            storage_1.default.setItem('MDRNA_AMPLITUDE', storageAmplitude);
        }
        localStorage.removeItem('MDRNA_AMPLITUDE');
    }
};
const watchForLocaleAttributeChange = (element, onChangeLocale) => {
    const observer1 = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes') {
                const locale = element.getAttribute('data-locale');
                if (locale) {
                    onChangeLocale(locale);
                }
            }
        });
    });
    observer1.observe(element, { attributes: true });
    return observer1;
};
const watchForLocaleChange = (onChangeLocale) => {
    if (!('MutationObserver' in window)) {
        // Do nothing
        return;
    }
    let script = document.querySelector('script[data-amplitude-key]');
    let scriptObserver = script ? watchForLocaleAttributeChange(script, onChangeLocale) : undefined;
    const observer2 = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            Array.from(mutation.addedNodes).forEach((node) => {
                if (node instanceof Element && node.getAttribute('data-amplitude-key')) {
                    const locale = node.getAttribute('data-locale');
                    if (locale) {
                        onChangeLocale(locale);
                    }
                    script = node;
                    scriptObserver === null || scriptObserver === void 0 ? void 0 : scriptObserver.disconnect();
                    scriptObserver = watchForLocaleAttributeChange(node, onChangeLocale);
                }
            });
        });
    });
    observer2.observe(document.head, {
        subtree: true,
        childList: true
    });
};
const renderPrivacyModalWithConfiguration = () => {
    replaceDeprecatedStorage();
    const script = document.querySelector('script[data-amplitude-key]');
    if (script) {
        const amplitudeApiKey = (script === null || script === void 0 ? void 0 : script.getAttribute('data-amplitude-key')) || undefined;
        const locale = getLocale((script === null || script === void 0 ? void 0 : script.getAttribute('data-locale')) || undefined);
        const anonymize = script.getAttribute('data-anonymize') === 'false' ? false : true;
        /* eslint-disable no-console */
        if (!amplitudeApiKey) {
            console.warn('A data-amplitude-key attribute is required for Moderna tracking.');
        }
        else if (!locale) {
            console.warn('A data-locale attribute is required for Moderna tracking.');
        }
        else {
            if (document.body) {
                renderPrivacyModal(amplitudeApiKey, locale, anonymize);
            }
            else if ('MutationObserver' in window) {
                const observer = new MutationObserver(() => {
                    if (document.body) {
                        renderPrivacyModal(amplitudeApiKey, locale, anonymize);
                        observer.disconnect();
                    }
                });
                observer.observe(document.documentElement, { childList: true });
            }
            else {
                document.addEventListener('DOMContentLoaded', () => {
                    renderPrivacyModal(amplitudeApiKey, locale, anonymize);
                });
            }
        }
        /* eslint-enable no-console */
    }
};
// @ts-ignore
if (!window.MDRNA_TRACKING) {
    // @ts-ignore
    window.MDRNA_TRACKING = true;
    renderPrivacyModalWithConfiguration();
}
